import React from "react";
import EotELogo from "../data/Logos/EotE.png";
import AoRLogo from "../data/Logos/AoR.png";
import FaDLogo from "../data/Logos/FaD.png";

export const SOURCE_TO_LOGO = {
  // Edge of the Empire
  "Edge of the Empire Core Rulebook": EotELogo,
  "Edge of the Empire Beginner Game": EotELogo,
  "Enter the Unknown": EotELogo,
  "Dangerous Covenants": EotELogo,
  "Far Horizons": EotELogo,
  "Fly Casual": EotELogo,
  "Special Modifications": EotELogo,
  "No Disintegrations": EotELogo,
  "Suns of Fortune": EotELogo,
  "Lords of Nal Hutta": EotELogo,
  // Age of Rebellion
  "Age of Rebellion Core Rulebook": AoRLogo,
  "Age of Rebellion Beginner Game": AoRLogo,
  "Stay on Target": AoRLogo,
  "Desperate Allies": AoRLogo,
  "Lead by Example": AoRLogo,
  "Forged in Battle": AoRLogo,
  "Fully Operational": AoRLogo,
  "Cyphers and Masks": AoRLogo,
  "Strongholds of Resistance": AoRLogo,
  // Force and Destiny
  "Force and Destiny Core Rulebook": FaDLogo,
  "Force and Destiny Beginner Game": FaDLogo,
  "Keeping the Peace": FaDLogo,
  "Endless Vigil": FaDLogo,
  "Savage Spirits": FaDLogo,
  "Unlimited Power": FaDLogo,
  "Knights of Fate": FaDLogo,
  "Disciples of Harmony": FaDLogo,
  "Nexus of Power": FaDLogo,
};

const getSourceTexts = (source) => {
  if (typeof source === "string") return [source];
  if (Array.isArray(source)) return source.map((s) => (typeof s === "string" ? s : s.__text || ""));
  if (typeof source === "object" && source !== null) return [source.__text || ""];
  return [];
};

const GameLineLogos = ({ source }) => {
  const texts = getSourceTexts(source);
  const seen = new Set();
  const logos = texts
    .map((t) => SOURCE_TO_LOGO[t])
    .filter((logo) => logo && !seen.has(logo) && seen.add(logo))
    .map((logo, i) => (
      <img key={i} src={logo} className={logo === AoRLogo ? "aor-logo" : undefined} style={{ height: "1em", verticalAlign: "middle" }} />
    ));
  return logos.length > 0 ? <span style={{ display: "inline-flex", gap: "4px" }}>{logos}</span> : null;
};

export default GameLineLogos;
